<template>
  <div class="frame">
    <div style="width: 100%;height:61px;background: #000;">
      <div style="width: 1730px;height: 60px; margin: 0 auto;">
        <!-- 导航栏 -->
        <Header
          v-if="this.identity !== ''"
          activeIndex="myTasks"
          :userName="userName"
          :identity="identity"
          :teacherGroup="teacherGroup"
          :role="role"
        />
        <!-- 角色选择框 -->
        <div v-if="((this.teacherGroup & 1) === 1) && ((this.teacherGroup & 16) === 16)" style="width: 160px; margin: -46px 0 0 50px">
          <el-radio-group v-model="role" size="small" @change="handleChange">
            <el-radio-button :label="1">平台老师</el-radio-button>
            <el-radio-button :label="2">本班老师</el-radio-button>
          </el-radio-group>
          <div class="role_div">
            <div @click="changeRole(1)"></div>
            <div @click="changeRole(2)"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="routine">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- tab---常规任务 -->
        <el-tab-pane
          label="常规任务"
          name="first"
          v-if="
            identity.indexOf('teacher') >= 0 || identity.indexOf('ocr') >= 0
          "
        >
          <Normal v-if="(this.teacherGroup  === 2  ||  this.teacherGroup === 4 || this.teacherGroup === 8 || (this.teacherGroup & 1 === 1 && this.teacherGroup & 16 === 16 && this.role === 1))" :list="tableData" />
          <Group v-if="(this.teacherGroup === 1 || (this.teacherGroup & 1 === 1 && this.teacherGroup & 16 === 16 && this.role === 2))" :list="tableData"/>
        </el-tab-pane>
        <!-- tab---审核任务 -->
        <el-tab-pane
          label="审核任务"
          name="second"
          v-if="identity.indexOf('auditor') >= 0"
        >
          <div>
            <!-- 任务状态筛选项 -->
            <div class="screen">
              <el-checkbox
                :indeterminate="isStateAll"
                v-model="checkStateAll"
                @change="handleStateChange"
                style="margin-right: 25px"
              >
                全选
              </el-checkbox>
              <el-checkbox-group
                v-model="checkedStates"
                @change="handleCheckedStateChange"
              >
                <el-checkbox v-for="state in states" :label="state" :key="state">
                  {{ state }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-table
              ref="singleTable"
              :data="
                tableData2 &&
                tableData2.slice((pageNum - 1) * pageSize, pageNum * pageSize)
              "
              :highlight-current-row="isHighLight"
              @row-click="handleCurrentChange"
              style="width: 100%"
              border
              max-height="600"
              row-class-name="my_tasks_row"
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="任务类型"
                :formatter="workType"
                align="center"
                width="240"
              >
              </el-table-column>
              <el-table-column
                property="start_time"
                label="任务领取时间"
                :formatter="dateFormat"
                width="240"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="deadline"
                label="任务截止时间"
                :formatter="dateFormat"
                width="240"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="任务时限"
                :formatter="timeLimit"
                width="120"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="任务状态"
                :formatter="progress"
                width="120"
                align="center"
                column-key="state"
              >
              </el-table-column>
              <el-table-column
                property="result"
                label="审核结果"
                width="120"
                align="center"
                column-key="result"
              >
              </el-table-column>
              <el-table-column
                property="description"
                label="审核描述"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              v-if="this.pageType === 0 && this.pageType2 === 0"
              :current-page="pageNum"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData2.length"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange2"
              style="margin: 32px 0 0 538px"
            >
            </el-pagination>
            <el-button
              class="btn2"
              type="primary"
              @click="handleJump()"
              style="
                margin: 2% 40%;
                width: 300px;
                height: 60px;
                font-size: 20px;
                display: none;
              "
              >继续完成</el-button
            >
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
import Header from "./header.vue";
import Normal from "./components/normal.vue";
import Group from "./components/group.vue";
const stateOptions = ["进行中", "已完成", "已超时", "已失效", "待提交"];

export default {
  data() {
    return {
      role: 2,  // 1---平台老师   2---本班老师(默认值)
      activeName: "first",
      userName: "",
      identity: "",
      tableData: [],
      tableData2: [],
      list: [],      // 和初始的tableData2的值一样，数据不变
      data: {
        id: 0,
        mode: 1,
      },
      pageNum: 1, // 当前页数
      pageSize: 10, // 每页显示条目数
      taskType: "", //任务类型---决定跳转到哪个页面
      tabType: "", //判断tab展示的是常规任务还是审核任务,默认为常规任务
      //控制表格行是否点击高亮
      isHighLight: true,
      pageType: 0, //控制分页栏的显示和隐藏
      pageType2: 0,
      teacherGroup: 2, // teacher_group=1是，按照分组的方式显示，其他值（可能是2或者4等等），都按照原来的方式显示
      // 任务状态筛选项变量
      isStateAll: false,                          // false --- 全选状态
      checkStateAll: true,
      checkedStates: ["进行中", "已完成", "已超时", "已失效", "待提交"], // 已选中筛选项
      states: stateOptions,
    };
  },
  components: {
    Header,
    Normal,
    Group,
  },
  mounted() {
    this.init();
  },
  methods: {
    changeRole (a) {
      if(this.role === 2 && a===1){
        this.$confirm('切换为平台老师后，能够领取作文，但无法批改自己班级学生的作文，是否继续？', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.role = 1;
          this.handleChange();
        })
      };
      if(this.role === 1 && a===2){
        this.$confirm('切换为本班老师后，只能批改自己班级学生的作文，无法领取作文，是否继续？', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.role = 2;
          this.handleChange();
        })
      };
    },
    handleChange(){
      // 每次切换角色时，先清空localStorage中的role(以及表格数据的值)，再重新赋值
      this.tableData = [];
      this.tableData2 = [];
      localStorage.removeItem("role");
      localStorage.setItem("role", this.role);
      this.handleGetData({role: this.role});
    },
    init() {
      // 获取token，并解析
      let info = window.location;
      if (info.search) {
        // 将token存储在本地(外语通跳转时获取token并保存在localStorage中)
        localStorage.setItem("token", info.search.substring(7));
        localStorage.setItem("role", 2);
        // 解析token
        let token = jwt_decode(info.search.substring(7));
        // 获取教师分组信息
        this.teacherGroup = token.teacher_group;
        // 调用方法渲染页面
        this.handleInitialize(token);
      } else if (localStorage.getItem("token")) {
        let token = jwt_decode(localStorage.getItem("token"));
        // 获取教师分组信息
        this.teacherGroup = token.teacher_group;
        this.handleInitialize(token);
        // 获取当前账号的角色信息
        this.role = Number(localStorage.getItem("role"));
      } else {
        this.$message({
          message: "未登录，请进行登录",
          type: "warning",
          duration: 1000,
          onClose: (res) => {
            this.clearCache();
          },
        });
      }
    },
    // mytasks接口
    handleGetData(obj){
      home
        .workDetail(obj)
        .then((res) => {
          if (res.data.retcode === 0) {
            //获取后台数据，渲染表格内容
            this.tableData = res.data.routine_task_data;
            this.list = res.data.audit_task_data;
            this.tableData2 = res.data.audit_task_data;
            // if(res.data.audit_task_data.length > 0){
            //   res.data.audit_task_data.map(item => {
            //     if(item.state !== 'completed' || item.result !== '通过'){
            //       this.list.push(item);
            //       this.tableData2.push(item);
            //     }
            //   })
            // };
            if (this.tableData.length === 0 && this.tableData2.length > 0) {
              this.tabType = "审核任务";
              this.activeName = "second";
            } else {
              this.tabType = "常规任务";
              this.activeName = "first";
            };
          } else if (res.data.retcode === 1 || res.data.retcode === 2) {
            this.$alert(res.data.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.clearCache();
              },
            });
          } else {
            this.$alert(res.data.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 解析token获取用户信息，调接口加载页面
    handleInitialize(token) {
      // 获取用户信息（用户名和用户身份）
      this.identity = token.identity;
      this.userName = token.nickname;
      let obj = {};
      if(((this.teacherGroup & 1) === 1) && ((this.teacherGroup & 16) === 16)){
        obj.role = Number(localStorage.getItem('role'));
      } else {
        obj = {};
      }
      this.handleGetData(obj);
    },

    // tab点击事件
    handleClick(tab) {
      this.tabType = tab.label;
      if (this.tabType === "常规任务") {
        $(".btn2").css("display", "none");
        this.isHighLight = false;
      }
    },
    // 表格行点击事件--常规任务、审核任务
    handleCurrentChange(val) {
      this.isHighLight = true;
      if (val.state === "completed") {
        $(".btn2").css("display", "none");
        this.$message({
          message: "该任务已完成！",
          type: "success",
          duration: 1000,
          onClose: (res) => {},
        });
      } else if (val.state === "waiting") {
        $(".btn2").css("display", "none");
        this.$message({
          message: "正在等待相关责任人提交结果！",
          type: "warning",
          duration: 1000,
          onClose: (res) => {},
        });
      } else if (val.state === "disabled") {
        $(".btn2").css("display", "none");
        this.$message({
          message: "该任务已失效！",
          type: "error",
          duration: 1000,
          onClose: (res) => {},
        });
      } else if (val.state === "delayed") {
        this.taskType = val.type;
        this.data.id = val.task_id;
        $(".btn2").css("display", "block"); //控制按钮的显示和隐藏
        this.$message({
          message: "任务已超时，请尽快完成",
          type: "error",
          duration: 1000,
          onClose: (res) => {},
        });
      } else {
        this.taskType = val.type;
        this.data.id = val.task_id;
        $(".btn2").css("display", "block"); //控制按钮的显示和隐藏
      }
    },
    //继续完成按钮--页面跳转接口
    handleJump() {
      if (this.tabType === "审核任务") {
        if (this.taskType === "verify") {
          let data = {
            taskid: this.data.id,
            mode: this.data.mode,
          };
          home
            .taskReview(data)
            .then((res) => {
              if (res.data.retcode === 0) {
                this.$router.push({
                  path: "taskReview",
                  query: { id: this.data.id, mode: this.data.mode },
                });
              } else if (res.data.retcode === 1 || res.data.retcode === 2) {
                this.$alert(res.data.retmsg, "登录异常", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.clearCache();
                  },
                });
              } else {
                this.$alert(res.data.retmsg, "请求失败", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
        if (this.taskType === "check") {
          this.$router.push({ path: "ocrReview", query: this.data });
        }
      }
    },
    // 分页栏事件(常规和审核定义共用的方法)
    handleCurrentChange2(val) {
      $(".btn2").css("display", "none");
      this.isHighLight = false;
      this.pageNum = val;
    },
    handleSizeChange(val) {
      $(".btn2").css("display", "none");
      this.isHighLight = false;
      this.pageSize = val;
    },
    //表格时间格式修改
    dateFormat(row, column, cellValue) {
      var fecha = require("fecha");
      return cellValue
        ? fecha.format(new Date(cellValue), "YYYY-MM-DD HH:mm:ss")
        : "";
    },
    //计算得到批改时限
    timeLimit(row) {
      let time = row.duration;
      return time + "小时";
    },
    //任务类型列转为文字
    workType(row) {
      if (row.type === "correct") {
        return "作文批改";
      }
      if (row.type === "ocr") {
        return "OCR识别";
      }
      if (row.type === "check") {
        return "OCR识别结果审核";
      }
      if (row.type === "verify") {
        return "作文批改结果审核";
      }
    },
    // 任务进度列转为文字
    progress(row) {
      if (row.state === "inprogress") {
        return "进行中";
      }
      if (row.state === "completed") {
        return "已完成";
      }
      if (row.state === "delayed") {
        return "已超时";
      }
      if (row.state === "waiting") {
        return "待提交";
      }
      if (row.state === "disabled") {
        return "已失效";
      }
    },
    // 审核任务表格数据过滤
    handleFilter() {
      this.tableData2 = this.list;
      let arr = [];
      if(this.checkedStates.length > 0){
        for(let n=0;n<this.tableData2.length;n+=1){
          let value = this.tableData2[n];
          for (let i = 0; i < this.checkedStates.length; i += 1) {
            if (this.progress(value) === this.checkedStates[i]) {
              arr.push(value);
            };
          };
        };
      };
      return arr;
    },
    // 任务状态筛选项全选操作
    handleStateChange(val) {
      this.checkedStates = val ? stateOptions : [];
      this.isStateAll = false;
      this.tableData2 = this.handleFilter();
    },
    // 任务状态筛选项变化时的回调
    handleCheckedStateChange(value) {
      this.pageNum = 1;
      this.checkedStates = [];
      value.map((item) => {
        this.checkedStates.push(item);
      });
      let checkedCount = value.length;
      this.checkStateAll = checkedCount === this.states.length;
      this.isStateAll = checkedCount > 0 && checkedCount < this.states.length;
      this.tableData2 = this.handleFilter();
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
<style scoped>
.frame {
  width: 100%;
  height: 900px;
  /* border: 1px solid #ff0; */
  background: #e9e9e9;
}
a {
  text-decoration: none;
}
.routine {
  padding: 0 25px;
  margin: 0 auto;
  width: 1560px;
  /* width: 80%; */
  background: #fff;
}
.role_div {
  display: flex;
  position: relative;
  top: -32px;left: 0;
  cursor: pointer;
}
.role_div div {
  width: 80px;
  height: 32px;
}
.screen {
  display: flex;
  height: 50px;
  line-height: 50px;
}
</style>
<style>
.el-table__body tr.current-row > td {
  background-color: #66b1ff !important;
}
.el-tabs__item {
  font-size: 20px;
}
.el-tabs__active-bar {
  width: 80px;
}
.el-table tr.my_tasks_row:hover > td {
  background: #66b1ff;
}
/* .el-table tr.my_tasks_row:hover > td div button span {
  color: #fff;
} */
</style>
